<div
	class="ada-colspan-1"
	data-container-selector="ada-card-body"
>
	<ada-table
		#HistoryTable
		data-testid="MetadataHistoryTable"
		[checkboxesEnabled]="true"
		[customMessage]="'No Git History to Show'"
		[data]="objectHistoryTableData$ | async"
		[handlePagination]="false"
		[includeActionsColumn]="true"
		[includeSorting]="false"
		[rowMenu]="RowMenu"
		[showPageSkipButtons]="false"
		(currentPageChange)="handleCurrentPageChanged($event)"
		(rowsPerPageChange)="handleRowsPerPageChanged($event)"
	>
		<ng-template
			adaTableColumn
			let-row
		>
			<span class="ada-color-foreground">{{ row.description || '--' }}</span>
		</ng-template>
		<ng-template
			adaTableColumn
			let-row
		>
			<span class="ada-color-foreground">
				{{ row.datetime ? (row.datetime | adaLocalizedDate: 'short') : '--' }}
			</span>
		</ng-template>
		<ng-template
			adaTableColumn
			let-row
		>
			<span class="ada-color-foreground">{{ row.userLogin || '--' }}</span>
		</ng-template>
	</ada-table>
	<ada-menu
		#RowMenu
		[items]="historyTableMenus"
		(isOpenChange)="disableRowMenus($event)"
	/>
</div>

<ada-overlay
	#ObjectHistoryOverlay
	id="ObjectHistoryOverlay"
	[title]="'Object History'"
>
	<ada-container
		*adaTemplateMarker
		padding="1rem"
	>
		@for (prop of overlayProps; track $index) {
			<ada-container
				[className]="prop.color"
				[colCount]="2"
				[colSpan]="1"
				[padding]="'0px ' + ui.Spacing.SPACING_MEDIUM"
			>
				<ada-container [colSpan]="1">
					<ada-text
						[content]="prop.key + '\t: '"
						[textColor]="prop.color"
					/>
				</ada-container>
				<ada-container [colSpan]="1">
					<ada-text
						[content]="prop.value"
						[textColor]="prop.color"
					/>
				</ada-container>
			</ada-container>
		}
	</ada-container>
</ada-overlay>
